import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const DatePickerCustom = (props) => {
    const { sx, slotProps, format = "DD-MMM-YY", onChange = () => { }, ...otherProps } = props;

    const [cleared, setCleared] = useState(false);
    const [error, setError] = useState(false);

    const handleChange = (...params) => {
        const valueNew = params[0];
        if (props.minDate && valueNew) {
            if (valueNew.isBefore(props.minDate)) {
                setError(true);
                onChange("");
                return;
            }
        }
        setError(false);
        onChange(...params);
    };

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
                props.onChange && props.onChange(null);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    return (
        <DatePicker
            minDate={props?.minDate}
            format={format}
            onChange={handleChange}
            {...otherProps}
            sx={{
                "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-disabled": {
                    color: "#252525",
                },
                "& .MuiInputBase-root": {
                    borderRadius: 0,
                },
                marginTop: props.marginTop,
                ...sx,
            }}
            slotProps={{
                textField: {
                    placeholder: props.placeholder,
                    size: props.size,
                    required: props.required,
                    disabled: props.disabled,
                    error: error,
                    helperText: error ? "Date should be greater than today" : null,
                },
                field: { clearable: true, onClear: () => setCleared(true) },
                ...slotProps,
            }}
        />
    );
};

DatePickerCustom.defaultProps = {
    sx: {},
    size: "medium",
    marginTop: "5px",
    format: "DD-MMM-YY",
    placeholder: "DD-MMM-YY",
    required: false,
    disabled: false,
};

export default DatePickerCustom;
